import { BatchHttpLink } from 'apollo-link-batch-http'

const getHttpLink = config => new BatchHttpLink({
  uri: `${config.BFF_BASE_URI}/graphql`,
  credentials: 'same-origin',
  headers: {
    'Toast-Restaurant-External-ID': config.RESTAURANT_GUID
  }
})

export default getHttpLink
